import { Route, Routes } from "react-router-dom";
import { Login } from "./pages/Login";
import { CadastroUser } from "./pages/CadastroUsuer";
import { Home } from "./pages/ModuloAdocao/Home";
import { Animais } from "./pages/ModuloAdocao/Animais";
import { Eventos } from "./pages/ModuloAdocao/Eventos";
import { Agendamentos } from "./pages/ModuloAdocao/Agendamentos";
import { Tutores } from "./pages/ModuloAdocao/Tutores";
import { Relatorios } from "./pages/ModuloAdocao/Relatorios";
import {PrivateRoute, PrivateRouteAdmin} from "./PrivateRoute/privateRoutes";

function AppRoutesAdocao() {
  return (
    <Routes>
      <Route path="/" element={<Login />}></Route>
      <Route path="/cadastroUser" element={<CadastroUser />}></Route>
      <Route path="/home" element={<PrivateRoute><Home /></PrivateRoute>}></Route>
      <Route path="/animais/:tipo_animais?" element={<PrivateRoute><Animais /></PrivateRoute>}></Route>
      <Route path="/eventos" element={<PrivateRouteAdmin><Eventos /></PrivateRouteAdmin>}></Route>
      <Route path="/agendamentos" element={<PrivateRoute><Agendamentos /></PrivateRoute>}></Route>
      <Route path="/tutores" element={<PrivateRouteAdmin><Tutores /></PrivateRouteAdmin>}></Route> 
      <Route path="/relatorios" element={<PrivateRouteAdmin><Relatorios /></PrivateRouteAdmin>}></Route>
    </Routes>
  );
}

export default AppRoutesAdocao;
